import React from "react";
import { FormikHandlers, useField } from "formik";

import { ToggleSwitch, ToggleSwitchVariant } from "@ui/Atoms/ToggleSwitch";

interface Props {
  testId?: string;
  className?: string;
  name: string;
  disabled?: boolean;
  variant?: ToggleSwitchVariant;
  children: React.ReactNode;
  onChange?: (
    e: React.SyntheticEvent<HTMLInputElement> | FormikHandlers["handleChange"],
  ) => void;
}

const FormikToggleSwitch = (props: Props): React.ReactElement => {
  const [{ value, checked, onChange, ...field }] = useField<boolean>(
    props.name,
  );

  return (
    <ToggleSwitch
      {...field}
      testId={props.testId}
      className={props.className}
      variant={props.variant}
      value={value}
      checked={checked || value}
      disabled={props.disabled}
      onChange={e => {
        onChange(e);
        props.onChange?.(e);
      }}
    >
      {props.children}
    </ToggleSwitch>
  );
};

export { FormikToggleSwitch };
